import { isE2E } from '@/src/common/environment'
import type { ComponentProps } from 'react'
import * as Animatable from 'react-native-animatable'

type AnimateProps = ComponentProps<typeof Animatable.View>

const pulse = {
  0: {
    scale: 1,
  },
  0.25: {
    scale: 1.075,
  },
  0.5: {
    scale: 1.125,
  },
  0.75: {
    scale: 1.075,
  },
  1: {
    scale: 1,
  },
}

const defaultAnimation = {
  animation: pulse,
  easing: 'ease-out',
  iterationCount: 'infinite',
  iterationDelay: 200,
} as const satisfies AnimateProps

export const Animate = (props: AnimateProps) => {
  if (!isE2E) {
    return (
      <Animatable.View {...defaultAnimation} {...props}>
        {props.children}
      </Animatable.View>
    )
  } else {
    return <>{props.children}</>
  }
}
